import { TreeUtils } from '@duoduo-oba/ng-devui/utils';

export class TreeMaskService {

  public static creatMaskElement() {
    const maskElement = document.createElement('span');
    const style = {
      display: 'none',
      position: 'absolute',
      top: '0',
      right: '0',
      'z-index': '-1' // è®¾ç½®z-indexé²æ­¢æ¡ä½tree
    };
    maskElement.classList.add('devui-tree-mask');
    TreeUtils.addElStyles(maskElement, style);
    return maskElement;
  }

  public static addMask(hostElement: any, maskElement: any, treeWidth: number) {
    event.stopPropagation();
    if (treeWidth) {
      const nodeHeight = hostElement.clientHeight;
      maskElement.style.width = treeWidth + 'px';
      maskElement.style.height = nodeHeight + 'px';
      maskElement.style.display = 'block';
      hostElement.appendChild(maskElement);
    }
  }

  public static removeMask(hostElement: any, maskElement: any) {
    maskElement.style.display = 'none';
    hostElement.removeChild(maskElement);
  }

  public static calcWidth(treeNode: any, index?: number) {
    let treeWidth;
    // è¥ä¼ å¥çæwidthè¯´ææ¯nativeElementåç´æ¥è®¾ç½®å®½åº¦ï¼è¥æLengthè¯´ææ¯queryListåæ¾å­åç´ å®½åº¦
    if (treeNode.clientWidth) {
      treeWidth = treeNode.clientWidth;
    } else if (treeNode.length) {
      const nodeList = treeNode['_results'];
      if (index >= 0) { // è¥indexå°äº0åå¿å®ä¸åæ³ï¼NaNåundefinedé½ä¸å¤§äº0
        treeWidth = nodeList[index].nativeElement.clientWidth;
      } else { // indexä¸åæ³çåæ²¡ä¼ çé½æ¾å­elementéæå¤§ç
        treeWidth = Math.max(...nodeList.map(node => node.nativeElement.clientWidth));
      }
    }
    return treeWidth;
  }
}
